import * as api from "./api";

export const GET_WORKSPACES_COUNT = "magnifi/workspace/GET_WORKSPACES_COUNT";
export const CREATE_WORKSPACE_USER = "magnifi/workspace/CREATE_WORKSPACE_USER";
export const DELETE_WORKSPACE = "magnifi/workspace/DELETE_WORKSPACE";
export const GET_WORKSPACES = "magnifi/workspace/GET_WORKSPACES";
export const EDIT_WORKSPACE = "magnifi/organization/EDIT_WORKSPACE";
export const GET_WORKSPACE_ASSIGNABLE_USERS = "magnifi/workspace/GET_WORKSPACE_ASSIGNABLE_USERS";
export const ASSIGN_WORKSPACE_USER = "magnifi/workspace/ASSIGN_WORKSPACE_USER";
export const GET_WORKSPACE_USERS = "magnifi/workspace/GET_WORKSPACE_USERS";
export const GET_WORKSPACE_DETAILS = "magnifi/workspace/GET_WORKSPACE_DETAILS";
export const GET_WORKSPACES_BY_CATEGORY = "magnifi/workspace/GET_WORKSPACES_BY_CATEGORY";

export const getWorkspacesCount = () => {
  return {
    type: GET_WORKSPACES_COUNT,
    payload: api.getWorkspacesCount(),
  };
};

export const createWorkspaceUser = (data) => {
  return {
    type: CREATE_WORKSPACE_USER,
    payload: api.createWorkspaceUser(data),
  };
};

export const deleteWorkspace = (data) => {
  return {
    type: DELETE_WORKSPACE,
    payload: api.deleteWorkspace(data),
  };
};

export const getWorkspaces = (data) => {
  return {
    type: GET_WORKSPACES,
    payload: api.getWorkspaces(data),
  };
};

export const editWorkspace = (data) => {
  return {
    type: EDIT_WORKSPACE,
    payload: api.editWorkspace(data),
  };
};

export const getWorkspaceAssignableUsers = (data) => {
  return {
    type: GET_WORKSPACE_ASSIGNABLE_USERS,
    payload: api.getWorkspaceAssignableUsers(data),
  };
};

export const assignWorkspaceUser = (data) => {
  return {
    type: ASSIGN_WORKSPACE_USER,
    payload: api.assignWorkspaceUser(data),
  };
};

export const getWorkspaceUsers = (data) => {
  return {
    type: GET_WORKSPACE_USERS,
    payload: api.getWorkspaceUsers(data),
  };
};

export const getWorkspaceDetails = (data) => {
  return {
    type: GET_WORKSPACE_DETAILS,
    payload: api.getWorkspaceDetails(data),
  };
};

export const getWorkspacesByCategory = (data) => {
  return {
    type: GET_WORKSPACE_DETAILS,
    payload: api.getWorkspacesByCategory(data),
  };
};
